export const AccountTypes = {
  WORKER: "Worker Payment",
  VENDOR: "Vendor Payment",
  CLIENT: "Client Income",
  SUBCONTRACTOR: "Subcontractor Payment",
  EMPLOYEE: "Employee Payment",
  CASH: "Account Transaction",
  USER: "Account Transaction", // TODO: TBD - payment made to/from user's cash account
  BANK: "Account Transaction",
};
